import { Pressable, Text, View } from 'react-native'
import { RefreshCw, X } from 'lucide-react-native'
import { useTranslation } from 'react-i18next'
import { colors } from '@chillout/core'

interface UpdateBannerProps {
  onRefresh: () => void
  onDismiss: () => void
}

export function UpdateBanner({ onRefresh, onDismiss }: UpdateBannerProps) {
  const { t } = useTranslation()

  return (
    <View className="mx-6 mt-6 flex-row items-center gap-3 rounded-lg border border-warning/20 bg-warning/10 px-4 py-3">
      <View className="h-9 w-9 items-center justify-center rounded-full bg-warning/15">
        <RefreshCw size={18} color={colors.warning} strokeWidth={2} />
      </View>
      <View className="flex-1 flex-row flex-wrap gap-x-1">
        <Text className="text-sm font-semibold text-primary">{t('nav.updateAvailable')}</Text>
        <Text className="text-sm font-normal text-secondary">{t('nav.updateMessage')}</Text>
      </View>
      <Pressable
        onPress={onRefresh}
        accessibilityRole="button"
        accessibilityLabel={t('nav.updateRefresh')}
        className="rounded-md border border-warning bg-canvas-primary px-3 py-1.5"
      >
        <Text className="text-sm font-semibold text-warning">{t('nav.updateRefresh')}</Text>
      </Pressable>
      <Pressable
        onPress={onDismiss}
        accessibilityRole="button"
        accessibilityLabel={t('nav.updateDismissAccessibilityLabel')}
        className="rounded-md p-1"
      >
        <X size={16} color={colors.text.secondary} strokeWidth={2} />
      </Pressable>
    </View>
  )
}